<template>
  <div style="height: 911px;">
    <div class="collectList">{{ $t('meg.collect') }}</div>
    <div class="collectBox" v-for="(item,index) in collectData" :key="index">
        <div class="left_main">
            <div style="width: 1.7rem;height: 2.125rem;background: #F6F6F6;border-radius: 0px 0px 0px 0px;opacity: 1;margin-top: .3rem;">
                <img :src="item.productImg" alt="" style="width: 1.325rem;height: 1.2875rem; margin-top: .4625rem;cursor: pointer;" @click="productBtn(item.productId)">
            </div>
            <div style="margin-left: .575rem;display: flex;flex-direction: column;text-align: left;">
                <span style="font-size: .25rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 400;color: #333333;margin-top: .425rem;">{{ item.productName }}</span>
                <span style="font-size: .2rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 400;color: #818AA0;margin-top: .3125rem;">{{ item.productExplain }}</span>
                <span style="cursor: pointer; font-size: .2rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 400;color: #818AA0;text-decoration: underline;margin-top: .7625rem;" @click="cancelCollect(item.productId)">{{ $t('meg.Cancelcollect') }}</span>
            </div>
        </div>
        <div class="right_main"> 
           <div style="display: flex;flex-direction: column;margin-top: 43px;text-align: left;margin-right: 120px;">
                <!-- <span style="font-size: 16px;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #333333;">颜色：经典黑色</span>
                <span style="font-size: 16px;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #333333;margin-top: 21px;">尺码：S</span> -->
           </div>
                <el-button class="orderBtn" @click="orderpush(item.productId)" v-if="roleType == 1">{{ $t('meg.order') }}</el-button>
        </div>
    </div>
    <div style="display: flex;justify-content: center;margin-bottom: .25rem;margin-top: .25rem">
      <el-pagination background layout="prev, pager, next" :total="total" :page-size="queryForm.pageSize"
        :current-page="queryForm.pageNum" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script setup>
import { getCollectByUser,productCollect } from "@/api/home.js"
import { selectIsInfo } from "@/api/order.js"
import { onMounted, ref,reactive } from "vue";
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router';

const collectData = ref([])
const roleType = localStorage.getItem("roleType")
const router = useRouter()
const total = ref(0)
const queryForm = reactive({
  pageSize: 10,
  pageNum: 1
})
onMounted(() => {
    getCollect()
})
const getCollect = () => {
    getCollectByUser().then(res => {
        if(res.data.code == 200) {
            collectData.value = res.data.rows
            total.value = res.data.total
        }
    })
}
const handleCurrentChange  = (val) => {
  queryForm.pageNum = val
  getList()
}

const orderpush = (productId) => {
    selectIsInfo().then(res => {
        if(res.data.code == 200) {
            router.push({path:"/placeOrder",query:{productId: productId}})
        } else {
            ElMessage.error(res.data.msg)
        }
      })
}
const cancelCollect = (productId) => {
    productCollect({productId:productId}).then(res => {
        if(res.data.code == 200) {
            ElMessage.success("取消收藏成功")
            getCollect()
        }
    })
}

const productBtn = (productId) => {
    router.push({ path: '/productdetails', query: { productId: productId } })
}
</script>

<style scoped>
.collectList {
    height: .6375rem;
    background: #EEEEEE;
    opacity: 1;
    margin: .3625rem .3rem 0 .3875rem;
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 700;
    color: #000000;
    line-height: .6375rem;
    text-align: left;
    padding-left: .25rem;
}
.collectBox {
    height: 2.6625rem;
    border-bottom: .0125rem solid #DDDDDD;
    margin-left: .3875rem;
    margin-right: .2875rem;
    display: flex;
    justify-content: space-between;
}
.left_main {
    display: flex;
}
.right_main {
    margin-right: .3rem;
    display: flex;
}
.orderBtn {
    width: 2.85rem;
    height: .5875rem;
    background: #002FA7;
    opacity: 1;
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
    margin-top: .425rem;
}
</style>
